import React, { useState } from "react";
import "../styles/HeroSection.css";
import { FaBars, FaTimes, FaLinkedin } from "react-icons/fa";
import { BiDownload, BiEnvelope } from "react-icons/bi";
import { AiOutlineArrowUp } from "react-icons/ai";
import { animateScroll as scroll } from "react-scroll";
import { motion } from "framer-motion";
import { Link } from '@react-email/link';
import {BsGithub} from "react-icons/bs";

const HeroSection = ({ nav, handleNav }) => {
	const scrollToTop = () => {
		scroll.scrollToTop({ smooth: "linear" });
	};

	const [visible, setVisible] = useState(false);

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop;
		if (scrolled > 300) {
			setVisible(true);
		} else if (scrolled <= 300) {
			setVisible(false);
		}
	};

	window.addEventListener("scroll", toggleVisible);

	const heroVariants = {
		hidden: {
			opacity: 0,
			y: "-50%",
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 1.4,
			},
		},
	};

	const resumeVariants = {
		hidden: {
			opacity: 0,
			x: "-50%",
		},
		visible: {
			opacity: 1,
			x: 0,
			transition: {
				duration: 1.4,
			},
		},
	};

	const contactVariants = {
		hidden: {
			opacity: 0,
			y: "50%",
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 1.4,
			},
		},
	};

	const menuVariants = {
		hidden: {
			opacity: 0,
		},
		visible: {
			opacity: 1,
			scale: [1, 1.2, 1.5, 1.2, 1],
			rotate: [0, 0, 360, 360, 360],
			borderRadius: ["50%", "50%", "50%", "50%", "50%"],
			transition: {
				duration: 1,
			},
		},
	};

	return (
		<div className='hero-section' name='home' id='home'>
			<div className='hero-overlay'></div>
			<motion.div
				// viewport={{ once: true }}
				variants={menuVariants}
				initial='hidden'
				whileInView='visible'
				onClick={handleNav}
				className='menu-icon'>
				{nav ? <FaTimes /> : <FaBars />}
			</motion.div>
			<motion.div
				variants={heroVariants}
				initial='hidden'
				whileInView='visible'
				className={visible ? "to-top-icon show" : "to-top-icon hide"}
				onClick={scrollToTop}>
				<AiOutlineArrowUp />
			</motion.div>
			<motion.div
				variants={heroVariants}
				initial='hidden'
				whileInView='visible'
				className='hero-content'>
				<h1 style={{display:'none'}}> Navkar Jain | Portfolio | Experienced Software Engineer | UMass Boston</h1>
				<p className='hero-intro'>
					<span>Navkar Jain</span>
				</p>
				<p className='hero-desc'>
					<span className='hero-desc-sub'>AI/ML Enthusiast | Experienced Software Engineer</span>
				</p>
			</motion.div>
			<motion.span
				variants={resumeVariants}
				initial='hidden'
				whileInView='visible'>
				<a
					href='Navkar-Jain-Resume.pdf'
					download='Navkar-Jain-Resume'
					className='hero-contact'>
					Download Resume<BiDownload className='cv-icon' />
				</a>
				<br></br>
			</motion.span>
			<motion.span
				variants={contactVariants}
				initial='hidden'
				whileInView='visible'>
				<ul className='hero-nav-links'>
					<li><Link  href="https://www.linkedin.com/in/navkar-j-1b7594110/" target='_blank' className='hero-nav-link'><FaLinkedin /></Link></li>
					<li><Link  href="https://www.github.com/navkar98" target='_blank' className='hero-nav-link'><BsGithub /></Link></li>
					<li><Link  href="mailto:n.jain001@umb.edu" target='_blank' className='hero-nav-link'><BiEnvelope /></Link></li>
				</ul>
			</motion.span>
			
		</div>
	);
};

export default HeroSection;
